import React from 'react'
import VendNumber, { vn, subtract } from 'vend-number'
import {
  Button,
  Modal,
  ModalActions,
  ModalHeader,
} from '@lightspeed/design-system-react'
import { T } from '@transifex/react'
import { RoundedNumber } from '../../CashPaymentModal'
import { useFormatCurrencyValue } from '../../../../helpers/formatNumberHooks'

interface ChangeProps {
  amountToPay: RoundedNumber
  paid: VendNumber
  pay: (paid: VendNumber) => void
}

export const Change: React.FC<ChangeProps> = ({ amountToPay, paid, pay }) => {
  const formatCurrencyValue = useFormatCurrencyValue()

  const change = subtract(amountToPay.rounded, paid)
  return (
    <Modal
      size="medium"
      dismissable
      onClose={() => pay(vn(amountToPay.rounded))}
    >
      <ModalHeader>
        <div className="vd-text-grand vd-align-center">
          <T
            _str="Give {change} change"
            change={formatCurrencyValue(-change)}
            _context="Amount of change to give to customer"
          />
        </div>
      </ModalHeader>
      <ModalActions>
        <Button
          block
          jumbo
          onClick={() => pay(vn(amountToPay.rounded))}
          variant="go"
          data-track="next-payment"
        >
          <T _str="Next payment" />
        </Button>
      </ModalActions>
    </Modal>
  )
}
